/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IImpersonationScope extends angular.IScope {
        selectedUser: any;
        searchUsers: any;
        impersonate(): void;
        endImpersonation() : void
        isCurrentlyImpersonating() : boolean;
    }


    export class ImpersonationController implements IController {
        constructor(
            private scope: IImpersonationScope,
            private testService: services.TestService,
            private userService: services.UserService)
        {
            scope.searchUsers = (a) => this.searchUsers(a);
            scope.impersonate = () => this.impersonate();
            scope.endImpersonation = () => this.endImpersonation();
            scope.isCurrentlyImpersonating = () => this.isCurrentlyImpersonating();
        }

        private searchUsers(viewValue) {
            var searchCriteria = new models.UserSearchCriteria();
            searchCriteria.userRepository = undefined;
            searchCriteria.userName = viewValue;
            return this.userService.searchUsers(searchCriteria);;
        }

        private impersonate() {
            if (this.scope.selectedUser) {
                this.testService.impersonate(this.scope.selectedUser.id).then(() => {
                    this.userService.setImpersonationUserId(this.scope.selectedUser.id);
                    alert("You are now impersonating the selected user");
                });
            } else {
                alert("Pick a user first");
            }
        }

        private endImpersonation() {
            this.testService.endImpersonation().then(() => {
                    this.userService.clearImpersonationUserId();
                    alert("You are no longer impersonating");
                });
        }

        private isCurrentlyImpersonating(): boolean {
            return this.userService.isCurrentlyImpersonating()
        }
    }
}

warsApp.registerController('ImpersonationController', ['$scope', 'testService', "userService"]);